import React, { useState, useEffect } from 'react'
import {
  getFundContentData,
  getDocByName,
} from '../../../components/FundDetails/Data/FundDetailsDataSource'
import { isInvestor } from '../../../global/authentication/authentication-manager'
import { getRelativeAssetBasePath } from '../../../global/environments/path.js'
import { encodeForURL } from '../../../global/formatters/string-formatter.js'

export function shouldDisplayFactsheet(
  mobileFundCard,
  factsheetData,
  investorCheck
) {
  return (
    mobileFundCard ||
    (investorCheck()
      ? factsheetData?.displayInvestor
      : factsheetData?.displayAdvisor)
  )
}

export const DownloadFactsheet = ({
  fund,
  mobileFundCard = false,
  factsheetData = {},
}) => {
  const [factsheet, setFactsheet] = useState(null)

  useEffect(() => {
    if (mobileFundCard) {
      const fetchData = async () => {
        const fundData = await getFundContentData(
          fund.cusip ? fund.cusip : fund.accountID
        )
        const url = getDocByName(
          fundData?.literature?.productDocuments,
          'Fact Sheet'
        )
        setFactsheet(url)
      }
      fetchData()
    }
  }, [fund])

  const factsheetUrl = mobileFundCard
    ? factsheet
    : factsheetData?.path
      ? `${getRelativeAssetBasePath()}/${factsheetData.path}`
      : null

  const displayFactsheet = shouldDisplayFactsheet(
    mobileFundCard,
    factsheetData,
    isInvestor
  )

  if (!factsheetUrl || !displayFactsheet) return null

  return (
    <a
      href={encodeForURL(factsheetUrl)}
      download
      data-analytics="Fact Sheet"
      aria-label={`Download ${fund.fundName} Factsheet`}
      className={`${mobileFundCard ? 'Button Button--primary Button--small u-textColorWhite u-paddingHoriz3gu u-margin2gu' : 'u-flex u-flexJustifyCenter u-textSizeMsrp3 u-textColorBrandLight'}`}
    >
      <span
        className={`${mobileFundCard ? 'adel-material-symbols' : 'Icon--material u-posStatic'}`}
        aria-hidden="true"
      >
        download
      </span>
      {mobileFundCard ? 'Download Factsheet' : ''}
    </a>
  )
}
